var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Colors, InlineChildren, Stack, StackChildren, Text, } from '@doordash/design-language';
import Button from '@doordash/component-button';
import { TextField, Select } from '@doordash/component-fields';
import Toggle from '@doordash/component-toggle';
import * as Sentry from '@sentry/react';
import * as React from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import styled from 'styled-components';
import * as queryString from 'query-string';
import { testIds } from './testIds';
import CreateTeamStrings from './CreateTeamStrings';
import { useCreateTeamMutation, usePollingCreateTeamStatusQuery } from './hook';
// import the disconnect presentation component
import { Header } from '../../Header/Header';
import InfoBanner, { BannerType } from '../../Common/InfoBanner';
import { WrappedLink } from '../../NavButton';
import { BaseContainer, UnderHeaderContentWrapper, } from '../../Styles/Containers';
import track from '../../../utils/track';
import { useMediaQuery } from '../../Common/MediaQueryProvider';
import { useHasTeamData } from '../../AppStructure/hooks/useTeamData';
import { captureSentryEvent } from '../../../utils/errorHandling';
import { ProductFamily, ProductWorkflow, CustomerType, } from '../../../types/_ProductSpecificTypes';
import { WorkBenefit } from '../../../types/GloblalTypes';
import { CONTACT_SUPPORT_URL, DDFW_TERMS_OF_SERVICE_URL, DD_PRIVACY_POLICY_URL, } from '../../../constants/values';
import { SelfServeSignupTeamEvents } from '../../../constants/events';
var CreateTeamContentWrapper = styled(UnderHeaderContentWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100vh;\n  padding-top: 160px;\n  ", ";\n"], ["\n  height: 100vh;\n  padding-top: 160px;\n  ", ";\n"])), function (_a) {
    var isMobileTablet = _a.isMobileTablet;
    return "width: " + (isMobileTablet ? 75 : 40) + "vw";
});
var CreateTeamBaseContainer = styled(BaseContainer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  min-width: 100vw;\n"], ["\n  background-color: ", ";\n  min-width: 100vw;\n"])), Colors.SystemWhite);
var LegalTermLink = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: underline;\n"], ["\n  color: ", ";\n  text-decoration: underline;\n"])), Colors.SystemRed60);
var MAX_POLLING_ATTEMPT = 24;
var MAX_POLLING_ATTEMPT_BEFORE_TEXT_CHANGE = 10;
// TODO: remove this to show country drop donw
var SHOW_COUNTRY_OPTIONS = false;
var allowedCountryOptions = [
    { name: 'United States', value: 'US' },
];
var getCountryOptionKeyByName = function (name) {
    var selectedCountry = allowedCountryOptions.find(function (opt) { return opt.name === name; }) || { value: 'US' };
    return selectedCountry.value || 'US';
};
var getCountryNameByKeyName = function (key) {
    var selectedCountry = allowedCountryOptions.find(function (opt) { return opt.value === key; }) || { name: 'United States' };
    return selectedCountry.name || 'United States';
};
var CreateTeam = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var isMobileTablet = useMediaQuery().isMobileTablet;
    var location = useLocation();
    var parsedQueryString = queryString.parse(location.search);
    var companyNameFromQueryString = (_b = (_a = parsedQueryString) === null || _a === void 0 ? void 0 : _a.companyName) !== null && _b !== void 0 ? _b : '';
    var workBenefitFromQueryString = (_d = (_c = parsedQueryString) === null || _c === void 0 ? void 0 : _c.workBenefit) !== null && _d !== void 0 ? _d : '';
    var workBenefit = workBenefitFromQueryString === WorkBenefit.WORK_BENEFIT_DASHPASS
        ? WorkBenefit.WORK_BENEFIT_DASHPASS
        : WorkBenefit.WORK_BENEFIT_EXPENSED_MEALS;
    var leadId = (_f = (_e = parsedQueryString) === null || _e === void 0 ? void 0 : _e.leadId) !== null && _f !== void 0 ? _f : '';
    var _k = __read(React.useState(companyNameFromQueryString), 2), companyName = _k[0], setCompanyName = _k[1];
    var _l = __read(React.useState(false), 2), showCompanyNameFieldError = _l[0], setShowCompanyNameFieldError = _l[1];
    var _m = __read(React.useState(false), 2), isLegalTermChecked = _m[0], setIsLegalTermChecked = _m[1];
    var _o = __read(React.useState(false), 2), showLegalTermError = _o[0], setShowLegalTermError = _o[1];
    var _p = __read(React.useState('US'), 2), country = _p[0], setCountry = _p[1];
    var _q = __read(React.useState(false), 2), isPolling = _q[0], setIsPolling = _q[1];
    var _r = __read(React.useState(0), 2), successPollingCount = _r[0], setSuccessPollingCount = _r[1];
    var _s = __read(React.useState(0), 2), failurePollingCount = _s[0], setFailurePollingCount = _s[1];
    var _t = __read(React.useState(''), 2), createdTeamAccountId = _t[0], setCreatedTeamAccountId = _t[1];
    var _u = __read(React.useState(false), 2), companyCreationFailed = _u[0], setCompanyCreationFailed = _u[1];
    var toggleCompanyCreated = function (createdTeamAccountId) {
        setCreatedTeamAccountId(createdTeamAccountId);
    };
    var _v = __read(useHasTeamData({
        onCompleted: function (data) {
            if (data.teamData) {
                // <SignUpTeam /> logic will decide again where to redirect the users
                window.location.reload();
            }
            else {
                var createTeamVars = {
                    country: country,
                    teamName: companyName,
                    workBenefit: workBenefit,
                    leadId: leadId,
                };
                createTeam({
                    variables: createTeamVars,
                });
            }
        },
    }), 2), checkTeamDataBeforeCreateTeam = _v[0], teamDataLoading = _v[1].loading;
    var _w = __read(useCreateTeamMutation(), 2), createTeam = _w[0], _x = _w[1], createTeamLoading = _x.loading, createTeamData = _x.data, createTeamError = _x.error;
    var _y = usePollingCreateTeamStatusQuery({
        skip: !Boolean((_g = createTeamData === null || createTeamData === void 0 ? void 0 : createTeamData.createDdfwTeamAndTeamAccount) === null || _g === void 0 ? void 0 : _g.onboardingStatusId),
        variables: {
            onboardingStatusId: (_j = (_h = createTeamData === null || createTeamData === void 0 ? void 0 : createTeamData.createDdfwTeamAndTeamAccount) === null || _h === void 0 ? void 0 : _h.onboardingStatusId) !== null && _j !== void 0 ? _j : '',
        },
    }, {
        setSuccessPollCount: setSuccessPollingCount,
        setFailurePollCount: setFailurePollingCount,
        setIsPolling: setIsPolling,
    }, {
        onSuccess: function (createdTeamAccountId) {
            toggleCompanyCreated(createdTeamAccountId);
            if (workBenefit === WorkBenefit.WORK_BENEFIT_DASHPASS) {
                track(SelfServeSignupTeamEvents.DASHPASS_CREATE_TEAM_SUCCESS, {
                    team_account_id: createdTeamAccountId,
                });
            }
            else {
                track(SelfServeSignupTeamEvents.EXPENSED_MEALS_CREATE_TEAM_SUCCESS, {
                    team_account_id: createdTeamAccountId,
                });
            }
        },
        onError: function () {
            var _a, _b;
            setCompanyCreationFailed(true);
            captureSentryEvent(Sentry.Severity.Error, 'encountered error in createDdfwTeamAndTeamAccount', {
                productFamily: ProductFamily.ExpensedMeals,
                productWorkflow: ProductWorkflow.CreateTeam,
                customerType: CustomerType.SelfServeCustomer,
            }, {
                companyName: companyName,
                workBenefit: workBenefit,
                country: country,
                successPollingCount: successPollingCount,
                failurePollingCount: failurePollingCount,
                isPolling: isPolling,
                onboardStatusId: (_b = (_a = createTeamData === null || createTeamData === void 0 ? void 0 : createTeamData.createDdfwTeamAndTeamAccount) === null || _a === void 0 ? void 0 : _a.onboardingStatusId) !== null && _b !== void 0 ? _b : 'unknown',
            });
        },
    }), createTeamStatusLoading = _y.loading, createTeamStopPolling = _y.stopPolling;
    React.useEffect(function () {
        if (showCompanyNameFieldError && companyName) {
            setShowCompanyNameFieldError(!companyName.trim());
        }
    }, [companyName, showCompanyNameFieldError]);
    React.useEffect(function () {
        if (showLegalTermError && isLegalTermChecked) {
            setShowLegalTermError(false);
        }
    }, [isLegalTermChecked, showLegalTermError]);
    React.useEffect(function () {
        if (successPollingCount + failurePollingCount >= MAX_POLLING_ATTEMPT) {
            createTeamStopPolling();
            setIsPolling(false);
            setCompanyCreationFailed(true);
        }
    }, [successPollingCount, failurePollingCount, createTeamStopPolling]);
    React.useEffect(function () {
        if (!!createTeamError) {
            // TODO: fire some error event?
        }
    }, [createTeamError]);
    if (createdTeamAccountId) {
        return React.createElement(Redirect, { to: "/teams/admin/" + createdTeamAccountId + "/onboarding" });
    }
    var handleSubmitClick = function () {
        if (!companyName.trim() || !isLegalTermChecked) {
            if (!companyName.trim()) {
                setShowCompanyNameFieldError(true);
            }
            if (!isLegalTermChecked) {
                setShowLegalTermError(true);
            }
            return;
        }
        if (workBenefit === WorkBenefit.WORK_BENEFIT_DASHPASS) {
            track(SelfServeSignupTeamEvents.DASHPASS_CREATE_TEAM);
        }
        else {
            track(SelfServeSignupTeamEvents.EXPENSED_MEALS_CREATE_TEAM);
        }
        /**
         ** double check if the user has a team before creating a new team
         ** In rare cases such as the polling has stopped but the onboarding process took a longer time and it was successful,
         ** we will redirect the user to Work Portal instead of letting them to send duplicate requests for onboarding team
         **/
        checkTeamDataBeforeCreateTeam();
    };
    var pollingText = successPollingCount + failurePollingCount >
        MAX_POLLING_ATTEMPT_BEFORE_TEXT_CHANGE
        ? CreateTeamStrings.pollingText2()
        : CreateTeamStrings.pollingText1();
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { isAdmin: false, teamName: '', location: location, hideHeaderDropDown: true }),
        React.createElement(CreateTeamBaseContainer, null,
            React.createElement(CreateTeamContentWrapper, { isMobileTablet: isMobileTablet },
                React.createElement(Stack, { size: Stack.Sizes.Large },
                    React.createElement(StackChildren, { size: Stack.Sizes.XLarge },
                        React.createElement(Text, { styles: Text.Styles.PageTitle, "data-testid": testIds.title }, CreateTeamStrings.formTitle()),
                        React.createElement(StackChildren, { size: Stack.Sizes.Medium },
                            (createTeamError || companyCreationFailed) && (React.createElement(InfoBanner, { justification: InlineChildren.Justification.FlexStart, bannerType: BannerType.ERROR, bannerText: React.createElement("span", null,
                                    "Try again or",
                                    ' ',
                                    React.createElement(WrappedLink, { target: "_blank", href: CONTACT_SUPPORT_URL }, "contact support"),
                                    ' ',
                                    "for further assistance"), bannerTitle: CreateTeamStrings.errorBannerTitle() })),
                            React.createElement(TextField, { "data-testid": testIds.companyNameField, label: CreateTeamStrings.companyName(), onChange: function (name) {
                                    setCompanyName(name);
                                }, value: companyName, error: showCompanyNameFieldError
                                    ? CreateTeamStrings.companyNameRequiredError()
                                    : '', maxLength: 255 }),
                            SHOW_COUNTRY_OPTIONS && (React.createElement(Select, { isRequired: true, value: getCountryNameByKeyName(country), label: CreateTeamStrings.country(), accessibilityLabel: CreateTeamStrings.countryOptions(), onChange: function (name) {
                                    var selectedId = getCountryOptionKeyByName(name);
                                    setCountry(selectedId);
                                }, options: allowedCountryOptions })),
                            React.createElement(Toggle, { "data-testid": testIds.legalTermCheckbox, isSelected: isLegalTermChecked, renderLabel: function () { return (React.createElement(Text, null,
                                    "By clicking \u201CCreate Company\u201D, you agree to the",
                                    ' ',
                                    React.createElement(LegalTermLink, { href: DDFW_TERMS_OF_SERVICE_URL, target: "_blank", rel: "noopener noreferrer" }, "DoorDash for Work Terms and Conditions"),
                                    ".",
                                    React.createElement("br", null),
                                    "See the",
                                    ' ',
                                    React.createElement(LegalTermLink, { href: DD_PRIVACY_POLICY_URL, target: "_blank", rel: "noopener noreferrer" }, "DoorDash Privacy Policy"),
                                    ".")); }, error: showLegalTermError
                                    ? CreateTeamStrings.legalTermUnselectedError()
                                    : null, onChange: function () { return setIsLegalTermChecked(!isLegalTermChecked); } })),
                        React.createElement(StackChildren, { size: Stack.Sizes.Small },
                            React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center },
                                React.createElement(Button, { "data-testid": testIds.button, isInline: true, state: isPolling ||
                                        createTeamLoading ||
                                        createTeamStatusLoading ||
                                        teamDataLoading
                                        ? Button.States.Loading
                                        : Button.States.Default, onClick: handleSubmitClick }, CreateTeamStrings.createCompnay()),
                                isPolling ? (React.createElement(Text, { "data-testid": testIds.pollingText, styles: Text.Styles.Medium14, color: Colors.SystemGrey70 }, pollingText)) : null))),
                    React.createElement(StackChildren, { size: Stack.Sizes.Large }))))));
};
export default CreateTeam;
var templateObject_1, templateObject_2, templateObject_3;
